
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { GitCompare } from 'lucide-react';

const ComparisonSection = () => {
  return (
    <section 
      className="py-16 px-6 text-white relative"
      style={{
        backgroundImage: `url('/lovable-uploads/4ec80e04-609a-45ec-8bba-79e027417e3b.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="max-w-lg">
          {/* Left side - Text content */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold">
              Compare Companies Side by Side
            </h2>
            <p className="text-white/90 mb-6">
              Wanting to compare two potential employers side by side? Use our company comparison tool to see how they stack up!
            </p>
            <Button 
              asChild 
              size="lg" 
              className="bg-white text-redflags-red hover:bg-white/90 border-none"
            >
              <Link to="/compare" className="flex items-center gap-2">
                <GitCompare className="w-5 h-5" />
                Compare Companies
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
